module.exports = __webpack_public_path__ + "static/08b57253-2e0d-4c12-9c57-107f6c67bc49-3fe395dbd0b4dc5922ed3b2c7d32ce93.woff2";